import * as React from "react";
import { ServiceOutlinedIcon, Text, TextVariant } from "../../ui";
import { InvoicedService } from "../vehicleHistoryData";

/** One invoiced service, as the job page lists it: the name, then each part's quantity and name, and its number. */
export const InvoicedServiceRow: React.FC<{ service: InvoicedService }> = ({ service }) => (
  <div className="py-2 border-b border-[#44576e] last:border-b-0 flex items-start gap-2">
    <ServiceOutlinedIcon aria-hidden style={{ fontSize: "1.125rem", color: "#94a3b8", flexShrink: 0, marginTop: 3 }} />
    <div className="flex flex-col min-w-0">
      <Text variant={TextVariant.BODY1} style={{ fontWeight: 600 }}>
        {service.name}
      </Text>
      {/* By position: an invoice can list the same part twice. */}
      {service.parts.map((part, index) => (
        <React.Fragment key={`${index}-${part.name}`}>
          <Text variant={TextVariant.BODY2} className="text-[#e2e8f0]">
            {part.quantity ?? 1}X {part.name}
          </Text>
          {part.partNumber && (
            <Text variant={TextVariant.CAPTION} className="text-gray-400">
              Part # {part.partNumber}
            </Text>
          )}
          {/* As on the job page: an order with no parts store says so. */}
          {!part.hasPartsStore && (
            <Text variant={TextVariant.CAPTION} style={{ color: "#ca8a04", fontWeight: 600 }}>
              No Parts Store
            </Text>
          )}
        </React.Fragment>
      ))}
    </div>
  </div>
);
